import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlantGroupElement } from '../models/O3AdministrationModels/plant-model';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class OeeConfigurationService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  get baseUrl3(): string { return Constants.CORE_API_BASE_URL; }
  

  constructor(private http: HttpClient) { }

  //From UserManagement
  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }
  //Enterprise Group
  getTreeModal(data: any): Observable<PlantGroupElement[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<PlantGroupElement[]>(
      this.baseUrl + 'Common/GetTreeModal',
      data
    );
  }
  //Get Rate
  getRate(): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'OEEConfig/GetRate', {});
  }
  //
  getOEECalculationMethod(): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'OEEConfig/GetOEECalculationMethod',
      {}
    );
  }
  //
  getOutputType(): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'OEEConfig/GetOutputType', {});
  }
  //
  getVariableGroup(id: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'OEEConfig/GetVariableGroup',
      id
    );
  }

  //
  getVariable(id: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'OEEConfig/GetVariable', id);
  }
  //GetDowntimeCategory ==> id=5
  getDowntimeCategory(id: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'OEEConfig/GetDowntimeCategory',
      id
    );
  }
  //GetFaultByUnit parameter data = {PUId:5,CategoryId:1}
  getFaultByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetFaultByUnit', data);
  }

  //GetWasteCategory id=5
  getWasteCategory(id: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'OEEConfig/GetWasteCategory',
      id
    );
  }

  //GetOEEInfo
  getOEEInfo(id: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'OEEConfig/GetOEEInfo', id);
  }

  //SubmitOEEInfo
  submitOEEInfo(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'OEEConfig/SubmitOEEInfo',
      data
    );
  }

  //getFailureMode
  // getFailureModeDetails(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl2 + 'unitdefects', data);
  // }

  getFailureModeDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl3 + 'NCR/getFailureMode', data);
  }
}
